import React from 'react';

const EmployerScheduleContext = React.createContext();

export default EmployerScheduleContext;
